import { useEffect } from 'react';

import { useStore } from 'hooks/useStore';

import css from './BottomAdv.module.css';

const rotateAdv = () => {
  if (window !== undefined) {
    const helper = window['atiUserDataHelper'] || window['advHelper'];
    if (helper) {
      helper.getAdvManagerInstance()?.rotateAtiAdv(true);
    }
  }
};

const BottomAdv = () => {
  const {
    app: { searchResult },
    ui: { page },
  } = useStore();

  useEffect(() => {
    rotateAdv();
  }, [searchResult, page]);

  return (
    <div className={css.container}>
      <span ati-userdata-info="doc-preset=media_21" />
    </div>
  );
};

export { BottomAdv };
